import {Component, OnInit,QueryList, ViewChild,ViewChildren,AfterViewInit,ElementRef} from '@angular/core';
import {ModalController, PopoverController} from '@ionic/angular';
import {Api, User} from '../../providers';
import {HomePage} from "../home/home.page";
import {PostpopoverPage} from "../postpopover/postpopover.page";

@Component({
  selector: 'app-post',
  templateUrl: './post.page.html',
  styleUrls: ['./post.page.scss'],
})
export class PostPage implements AfterViewInit {
    public post:any;
    public comments:any;
    public text:string;
    public loading:boolean=true;
    constructor(public api:Api, public user: User,public modalController: ModalController,public popoverController: PopoverController) { }
    @ViewChildren('myVideos', { read: ElementRef }) myVideos: QueryList<ElementRef>;
    ngAfterViewInit() {

        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        };
        this.myVideos.changes.subscribe(() => { 
            const myVideos=this.myVideos.toArray();
            let handler=function(entries, observer){
                let played=false
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.muted = true
                        entry.target.isentery=true
                        
                    } else {
                        entry.target.isentery=false
                        entry.target.pause();
                    }
                });
                myVideos.forEach(video => {
    
                    console.log("video.nativeElement.isentery",video.nativeElement.isentery)
                    if(video.nativeElement.isentery && !played){
                        const promise=video.nativeElement.play();
                        // video.nativeElement.style="width: 100%;border:2px solid #333"
                        if (promise !== undefined) {
                            console.log("promis")
                            promise.catch(error => {
                                // Auto-play was prevented
                                // Show a UI element to let the user manually start playback
                            }).then(() => {
                                console.log("promis2")
                                // promise.play()
                                // Auto-play started
                            });
                        }
                        played=true
                    }else{
                        // video.nativeElement.style="width: 100%;"
                        video.nativeElement.pause();
                    }
                });
            }
            const observer = new IntersectionObserver(handler, options);
            
            this.myVideos.forEach((element: ElementRef) => {
                element.nativeElement.addEventListener('loadeddata', () => {
                    console.log('Video has been loaded');
                  });
                observer.observe(element.nativeElement);
                element.nativeElement.onclick=()=>{
                    console.log("fulll1")
                    if(element.nativeElement.muted){
                        element.nativeElement.muted = false
                        // if (element.nativeElement.requestFullscreen) {
                        //     element.nativeElement.requestFullscreen();
                        //   } else if (element.nativeElement.mozRequestFullScreen) { // Firefox
                        //     element.nativeElement.mozRequestFullScreen();
                        //   } else if (element.nativeElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
                        //     console.log("fulll")
                        //     element.nativeElement.webkitRequestFullscreen();
                        //   } else if (element.nativeElement.msRequestFullscreen) { // Internet Explorer and Edge
                        //     element.nativeElement.msRequestFullscreen();
                        //   }
                    }else{
                        element.nativeElement.muted = true
                    }
                }
              });
          });
    
      }
  ngOnInit() {
        this.getPost()
  }
  deletePost(mdl){
      const formData = new FormData();
      formData.append("userKey", this.user.account.userKey);
      formData.append("vr", this.user.account.version);
      formData.append("id", this.post.id);
      this.user.myLoading()
      const del = this.api.post("post/del", formData).subscribe(mres => {
          this.user.checkStatus(mres,mres=> {
              this.user.dismissLoading();
              mdl.dismissModal(true)
          },mres=>{})
      },err=>{
          this.user.dismissLoading();
      });
  }
  async pclick(){
      const popover = await this.popoverController.create({
          component: PostpopoverPage,
          componentProps:{
              post:this.post,
              delete:this.deletePost,
              mdl:this,
          },
          // event: ev,
          // mode:"ios",
          translucent: true
      });
      await popover.present();
      const { role } = await popover.onDidDismiss();
  }
    savePost(post){
        post.saved=!post.saved
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("id", post.id);
        formData.append("save", post.saved);
        const like = this.api.post("post/save", formData).subscribe(mres => {
            this.user.checkStatus(mres,res=>{},res=>{})
        },err=>{
        });
    }

    likePost(post){
        post.liked=!post.liked
        if(post.liked){
            post.like++;
        }else {
            post.like--;
        }
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("id", post.id);
        formData.append("liked", post.liked);
        const like = this.api.post("post/like", formData).subscribe(mres => {
            this.user.checkStatus(mres,res=>{},res=>{});
        },err=>{
        });
    }
    public dismissModal(dl:boolean=false) {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            'commentData':this.comments,
            'post':this.post,
            'dismissed': true,
            'dl':dl
        });
    }
    
    async sendComment(){
        if(!this.text){
            this.user.myToast("متن را وارد نمایید")
            return false;
        }
        this.loading=true
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("pid", this.post.id);
        formData.append("text", this.text);
        const upload$ = this.api.post("post/comment", formData).subscribe(mres => {
            this.user.checkStatus(mres,res=> {
                this.loading = false
                this.text = "";
                this.getPost()
            },res=>{})
        },err=>{
            this.loading=false
        });
    }
    async getPost(){

        this.loading=true
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("pid", this.post.id);
        const upload$ = this.api.post("post/full", formData).subscribe(mres => {
            // this.user.checkStatus(mres,mres=> {
                this.loading = false
                if (mres) {
                    this.post = mres["data"]["post"];
                    console.log(this.post)
                    this.comments = mres["data"]["cmts"];
                }
            },mres=>{})
        // },err=>{
        //     this.loading=false
        // });
    }
    async deleteCm(comment){
        if(!comment.owner && !this.post.owner){
            return false;
        }
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("cid", comment.cid);
        const upload$ = this.api.post("comment/del", formData).subscribe(mres => {
            this.user.checkStatus(mres,mres=> {
                    this.comments.splice(this.comments.indexOf(comment), 1);
                    this.post.comment=this.comments.length
            },mres=>{})
        },err=>{
            this.loading=false
        });
    }
    async presentHome(post) {
        const modal = await this.modalController.create({
            component: HomePage,
            // cssClass: 'my-custom-class',
            componentProps: {
                uid:post.uid,
                img:post.img,
                name:post.name,
                owner:post.owner
            }
        });
        await modal.present();
        const { data } = await modal.onWillDismiss();
    }
    dbclick(post){
        if(post.db==1){
            if(!post.liked) {
                this.likePost(post)
            }
            post.db=2;
            setTimeout(()=>{
                post.db=0;
            },800)
            return false
        }
        post.db=1;
        setTimeout(()=>{
            post.db=0;
        },1000)
    }
    handleLoad(media) {
        media.loaded=true
        console.log('Video loaded');
        // Perform additional actions here
      }
}
